import styles from './GridView.module.scss';

export const tileClassNames: Record<number, string | undefined> = {
  1: styles.tile__x1,
  2: styles.tile__x2,
  3: styles.tile__x3,
};
